import axios from '../utils/axios';

export const enqueueSubmissions = async (jobIds, mode = 'autopilot', priority = 0, queryId = null) => {
	const result = await axios.post('/api/auto-apply/submissions', {
		jobs: jobIds,
		mode,
		priority,
		query_id: queryId,
	}, {
		validateStatus: () => true,
	});

	return result;
};

export const getSubmissions = async () => {
	const result = await axios.get('/api/auto-apply/submissions');

	return result.data;
};

export const cancelSubmission = async (submissionUuid) => {
	const result = await axios.post(`/api/auto-apply/submissions/${submissionUuid}/cancel`, {}, {
		validateStatus: () => true,
	});

	return result;
};

export const getReviewContext = async (submissionUuid) => {
	const result = await axios.get(`/api/auto-apply/submissions/${submissionUuid}/review-context`, {
		validateStatus: () => true,
	});

	return result;
};

export const resubmitSubmission = async (submissionUuid) => {
	const result = await axios.post(`/api/auto-apply/submissions/${submissionUuid}/resubmit`, {}, {
		validateStatus: () => true,
	});

	return result;
};
